<template>
  <v-container fluid class="sonar-view">
    <v-row>
      <v-col cols="12">
        <project-card
          v-for="project in projects"
          :key="project.key"
          :project="project"
        ></project-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ProjectCard from './Sonar/ProjectCard.vue'
const { mapState, mapActions } = createNamespacedHelpers('sonar')

export default {
  components: { ProjectCard },
  name: 'Sonar',
  async created() {
    await this.getAllMetrics()
  },
  methods: {
    ...mapActions(['getAllMetrics'])
  },
  computed: {
    ...mapState(['projects'])
  }
}
</script>

<style></style>
